var _style, _image, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPzt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1600 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @import url(pzt.css);\n")), _image || (_image = /*#__PURE__*/React.createElement("image", {
    href: "pzt.jpg",
    height: 1195.77,
    width: 2125.81,
    transform: "translate(-219.196,38.8526)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pzt",
    d: "M46 459l4 -1 730 2 -1 -113h788l3 257 9 1 -21 248 -1266 -149 -266 4 -5 -228 1 -3 2 -3 1 -2 2 -3 2 -2 3 -2 3 -2 2 -2 3 -1 3 -1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bu",
    building: "A",
    d: "M797 363v113h-722l38 215h574l186 -13 18 -94h423v136l210 21v-259h24v-119z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPzt);
export default __webpack_public_path__ + "static/media/pzt.c933ae62b5991097acc2d10acad38b96.svg";
export { ForwardRef as ReactComponent };